import { render, staticRenderFns } from "./liveBroadcast.vue?vue&type=template&id=8ec18e72"
import script from "./liveBroadcast.vue?vue&type=script&lang=js"
export * from "./liveBroadcast.vue?vue&type=script&lang=js"
import style0 from "./liveBroadcast.vue?vue&type=style&index=0&id=8ec18e72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports